// Vendor imports
const Promise = require('bluebird')
// Shared imports
const { ExtendableError } = require('shared/error-utils')
// Client lib imports
const airbrake = require('client/lib/airbrake')

// Constants

const DEFAULT_EXTENSION_TIMEOUT = 100

// Exported functions

async function clearUrlCache(urlId) {
  return callExtension(ext => ext.clearUrlCache(urlId))
  .catch(() => {
    // Swallow the error and do nothing
    return null
  })
}

async function clearUrlStateCache(urlId) {
  return callExtension(ext => ext.clearUrlStateCache(urlId))
  .catch(() => {
    // Swallow the error and do nothing
    return null
  })
}

async function clearUserCache() {
  return callExtension(ext => ext.clearUserCache())
  .catch(() => {
    // Swallow the error and do nothing
    return null
  })
}

async function clearUserStateCache() {
  return callExtension(ext => ext.clearUserStateCache())
  .catch(() => {
    // Swallow the error and do nothing
    return null
  })
}

async function filterDomain(domain) {
  return callExtension(ext => ext.filterDomain(domain))
  .catch(() => {
    // Swallow the error and do nothing
    return null
  })
}

async function ping() {
  return callExtension(ext => ext.ping())
  .catch(() => {
    // Swallow the error and do nothing
    return null
  })
}

async function showUrl(url, recState) {
  return callExtension((ext => ext.showUrl(url, { recState })), 500)
}

// Exports

module.exports = {
  clearUrlCache,
  clearUrlStateCache,
  clearUserCache,
  clearUserStateCache,
  filterDomain,
  ping,
  showUrl
}

// Internal helpers

const getExtensionHandle = () => window.mixext

async function callExtension(call, timeout) {
  const extensionHandle = getExtensionHandle()
  if (!extensionHandle) {
    throw new MixExtensionNotInstalledError()
  }
  try {
    return Promise.resolve(call(extensionHandle))
    .timeout(timeout || DEFAULT_EXTENSION_TIMEOUT)
  } catch (err) {
    airbrake.notify(err)
    throw err
  }
}

class MixExtensionNotInstalledError extends ExtendableError {
  constructor() {
    super('Mix Extension is not installed')
    this.name = 'MixExtensionNotInstalledError' // Preserve name after minifying
  }
}
